document.addEventListener('DOMContentLoaded', function () {
  const fomoCarouselImages = document.getElementsByClassName("carousel-image");
  const fomoCarouselCount = fomoCarouselImages.length;
  
  if(fomoCarouselImages.length > 1){
    let index = 0;
    
    const speedSettings = document.getElementsByClassName("carousel-target-bg")[0];
    const speed = document.getElementsByClassName("carousel-target-bg")[0] && speedSettings.dataset && speedSettings.dataset.speed ? speedSettings.dataset.speed * 1000 : 4000;
    
    const swap = setInterval(async function() {
      const useMobile = window.innerWidth <= 900;
      const useImage = document.getElementsByClassName('carousel-target-image').length > 0 && !useMobile;
      const target = useImage ? "carousel-target-image" : "carousel-target-bg" ;
      let requiredElement = document.getElementsByClassName("carousel-target-bg")[0];
      let targetUpdateDesktop = document.getElementsByClassName(`carousel-image-${ index }`)[0];
      
      let targetElement = targetUpdateDesktop;
      if(useMobile){
        let targetUpdateMobile = document.getElementsByClassName(`carousel-mobile-image-${ index }`);
        if(targetUpdateMobile.length > 0){
          targetElement = targetUpdateMobile[0];
        }
      }
      
      let textElement = document.getElementsByClassName('title-text');
      if(textElement.length > 0){
        let targetText = document.getElementsByClassName(`carousel-image-text-${ index }`)[0];  
        textElement[0].innerText = targetText.innerText;
      }
      
      if(useImage){
        const hiddenImage = document.getElementsByClassName('hidden-image');
        if(hiddenImage.length > 0) hiddenImage[0].src = targetElement.src;
      }
      
      requiredElement.style['background-image'] = `url('${targetElement.src}')`;  
      const targets = document.getElementsByClassName('carousel-target-image');
      for(let i = 0, c = targets.length;i<c;i++){
        if(targets[i].tagName == "IMG") targets[i].src = targetElement.src;
        else targets[i].style['background-image'] = `url('${targetElement.src}')`;
      }
      index += 1;
      if(index == fomoCarouselCount) index = 0;
    },speed);
  }

  window.fomoScrollTo = function(id){
    const target = document.getElementById(id);
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }
});